var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "meno"
    }
  }, [_vm._v("Meno:")]), _c('input', {
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "meno",
      "data-name": "meno",
      "id": "meno",
      "required": ""
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "prezvisko"
    }
  }, [_vm._v("Priezvisko:")]), _c('input', {
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "prezvisko",
      "data-name": "prezvisko",
      "id": "prezvisko",
      "required": ""
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "adresa"
    }
  }, [_vm._v("Adresa:")]), _c('input', {
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "adresa",
      "data-name": "adresa",
      "id": "adresa",
      "required": ""
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email:")]), _c('input', {
    staticClass: "text-input w-input",
    attrs: {
      "type": "email",
      "maxlength": "256",
      "name": "email",
      "data-name": "email",
      "id": "email",
      "required": ""
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Telefon"
    }
  }, [_vm._v("Telefón:")]), _c('input', {
    staticClass: "text-input w-input",
    attrs: {
      "type": "tel",
      "maxlength": "256",
      "name": "Telefon",
      "data-name": "Telefon",
      "id": "Telefon",
      "required": ""
    }
  })])]);

}]

export { render, staticRenderFns }